export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const img = (u, w = 1200) =>
  u ? `${u}${u.includes("?") ? "&" : "?"}w=${w}&auto=format&fit=crop` : u;

export const inrFmt = (v) => `₹${Number(v || 0).toLocaleString("en-IN")}`;
